// @ts-nocheck
import { PREFERENCES_ERROR, PREFERENCES_LOADING, PREFERENCES_SUCCESS} from "../../Action/Type";

const initialState = {
    payload: {},
    loading: false,
    error: ''
}

export const PreferencesReducer = (state = initialState, action) => {
    switch (action.type) {
        case PREFERENCES_LOADING:
            return Object.assign({}, state, { loading: true })
        case PREFERENCES_SUCCESS:
            return Object.assign({}, state, { payload: action.data, loading: false })
        case PREFERENCES_ERROR:
            return Object.assign({}, state, { payload: action.data, loading: false })
        default:
            return state
    }
}

